export default __webpack_public_path__ + "static/media/v2200.33c0e6a3.jpg";